import { memo } from "react";
import type { ClosedInspectionRegister } from "../InspectionsLists.d";
import { useDate } from "@/hooks/use-date/useDate";
import InspectionAcitivities from "./InspectionActivities";
import StandMotorData from "./StandMotorData";
import { useTranslate } from "@/hooks/use-translate/useTranslate";
import CardDataLine from "./CardDataLine";

export interface ClosedInspectionCardProps {
  inspectionData: ClosedInspectionRegister;
}

const ClosedInspectionCard = ({
  inspectionData,
}: ClosedInspectionCardProps) => {
  const translate = useTranslate();
  const { formatDate, getTotalDays } = useDate();

  return (
    <div className="w-full px-6 py-4 border border-ib-gray-lightest bg-ib-white">
      <div className="w-full flex flex-row justify-between pb-2 border-b border-b-ib-gray-borders mb-4">
        <div className="w-full flex flex-row gap-x-6 pb-2">
          <StandMotorData
            label={translate("snStand")}
            value={inspectionData.snStand}
          />
          <StandMotorData
            label={translate("engine")}
            value={inspectionData.engineName}
          />
        </div>
        <InspectionAcitivities inspectionId={inspectionData.id} />
      </div>
      <div className="w-full flex flex-col gap-0.5">
        <CardDataLine
          label={translate("startDate")}
          value={formatDate(inspectionData.createdAt)}
        />
        <CardDataLine
          label={translate("endDate")}
          value={{
            date: formatDate(inspectionData.endDate),
            period: getTotalDays(
              inspectionData.createdAt,
              inspectionData.endDate,
            ),
          }}
        />
        <CardDataLine
          label={translate("esnOut")}
          value={inspectionData.esnOut}
        />
        <CardDataLine
          label={translate("colour")}
          value={inspectionData.colour}
        />
      </div>
    </div>
  );
};

export default memo(ClosedInspectionCard);
